export default "<router-outlet></router-outlet>\n\n<rodape-site></rodape-site>\n"